export default __webpack_public_path__ + "src/assets/icons/CarMap-b7bb717c.svg";